import { render, staticRenderFns } from "./TemplateParam.vue?vue&type=template&id=617f529c&"
import script from "./TemplateParam.vue?vue&type=script&lang=ts&"
export * from "./TemplateParam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports